import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { Landing } from "@/pages/Landing";
import { Register } from "@/pages/Register";
import { Login } from "@/pages/Login";
import { ResetPassword } from "@/pages/ResetPassword";
import { EmailSent } from "@/pages/EmailSent";
import { LoginSuccess } from "@/pages/LoginSuccess";
import { PrivacyPolicy } from "@/pages/PrivacyPolicy";
import { TermsOfService } from "@/pages/TermsOfService";
import { Contact } from "@/pages/Contact";
import "@/i18n";
import "@/styles/globals.css";

function App() {

  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes - accessible without authentication */}
        <Route path="/" element={<Landing />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/email-sent" element={<EmailSent />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/contact" element={<Contact />} />
        
        {/* Protected routes - require authentication */}
        <Route path="/login-success" element={<LoginSuccess />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
